import React from "react";

import {
  Block,
  Icon,
} from "../../components/Component";
import {useSelector} from "react-redux";

const UserProfileRegularPage = () => {
  const { account } = useSelector((state) => state.account);

  return (
    <React.Fragment>

      <Block className="px-6 py-8">
        <div className="nk-data data-list data-list-s2">
          <div className="data-head">
            <h6 className="overline-title font-bold">Basics</h6>
          </div>
          <div className="data-item">
            <div className="data-col">
              <span className="data-label">Full Name</span>
              <span className="data-value">{`${account.first_name} ${account.last_name}`}</span>
            </div>
            <div className="data-col data-col-end">
              <span className="data-more disable">
                <Icon name="lock-alt" />
              </span>
            </div>
          </div>
          <div className="data-item">
            <div className="data-col">
              <span className="data-label">Email</span>
              <span className="data-value">{ account.email }</span>
            </div>
            <div className="data-col data-col-end">
              <span className="data-more disable">
                <Icon name="lock-alt" />
              </span>
            </div>
          </div>
        </div>
        <div className="nk-data data-list data-list-s2">
          <div className="data-head">
            <h6 className="overline-title font-bold">Preferences</h6>
          </div>
          <div className="data-item">
            <div className="data-col">
              <span className="data-label">Date Format</span>
              <span className="data-value">DD/MM/YYYY</span>
            </div>
            <div className="data-col data-col-end">
              <span className="data-more disable">
                <Icon name="lock-alt" />
              </span>
            </div>
          </div>
        </div>
      </Block>
    </React.Fragment>
  );
};
export default UserProfileRegularPage;
